import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
  rsGroupEmptyRoot: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100px",
  },
}));

const GroupEmptyState = (props) => {
  const { text = "No Data Found!" } = props;
  const classes = useStyle();

  return (
    <>
      <Grid>
        <Grid className={classes.rsGroupEmptyRoot}>{text}</Grid>
      </Grid>
    </>
  );
};

export default GroupEmptyState;
